const cholesterolLevel = {
  Unknown: 1,
  VeryLow: 2,
  Low: 3,
  High: 4,
  VeryHigh: 5
}

export default cholesterolLevel;